import { NAV_KEYS } from '../../../utils/navigationEntitlements';

/*
 * ТЗ V5 №8: блок «Тип события» во вкладке «События».
 *
 * Категория события — категория его правила сейчас. Доступные типы выводятся
 * из granted_keys №7: summary.overview — нарушения, summary.business_metrics —
 * бизнес-метрики. Без ключей (backend без entitlements, старый каталог без
 * summary.*) вкладка ведёт себя как раньше — только нарушения: бизнес-API
 * без подтверждённого права не вызываем.
 *
 * В URL параметр `types`: пусто — все доступные типы (значение по умолчанию),
 * `none` — явно снятые все чекбоксы, иначе список через запятую.
 */

export const EVENT_TYPE_OPTIONS = [
  { id: 'violation', label: 'Нарушение', navKey: NAV_KEYS.SUMMARY_OVERVIEW },
  { id: 'business', label: 'Бизнес-метрика', navKey: NAV_KEYS.SUMMARY_BUSINESS_METRICS },
];

export const EVENT_TYPE_LABELS = Object.fromEntries(EVENT_TYPE_OPTIONS.map((option) => [option.id, option.label]));

const NONE = 'none';

export const allowedEventTypes = (keys) => {
  if (!Array.isArray(keys)) return ['violation'];
  const granted = EVENT_TYPE_OPTIONS.filter((option) => keys.includes(option.navKey)).map((option) => option.id);
  return granted.length > 0 ? granted : ['violation'];
};

/** URL → выбранные типы; недоступные по правам отбрасываются. */
export const parseEventTypes = (raw, allowed) => {
  const value = String(raw ?? '').trim();
  if (!value) return [...allowed];
  if (value === NONE) return [];
  const picked = new Set(value.split(',').map((item) => item.trim()));
  const valid = allowed.filter((id) => picked.has(id));
  // Права на выбранные типы отозваны — возвращаемся к доступным по умолчанию.
  return valid.length > 0 ? valid : [...allowed];
};

/** Выбранные типы → URL. Все доступные — пусто, чтобы адрес оставался чистым. */
export const serializeEventTypes = (types, allowed) => {
  const picked = allowed.filter((id) => types.includes(id));
  if (picked.length === 0) return NONE;
  if (picked.length === allowed.length) return '';
  return picked.join(',');
};

/**
 * Какой endpoint строит список: один тип — категорийный (тот же контракт и
 * сортировка, что раньше), оба — /analytics/events/unified с общим total и
 * пагинацией. Склеивать две страницы на фронте ТЗ запрещает.
 */
export const eventsSourceFor = (types) => {
  if (types.length === 0) return 'none';
  if (types.length === 1) return types[0];
  return 'unified';
};

const SINGLE_TO_PLURAL = [
  ['factory_id', 'factory_ids'],
  ['workshop_id', 'workshop_ids'],
  ['section_id', 'section_ids'],
  ['room_id', 'room_ids'],
  ['camera_id', 'camera_ids'],
  ['rule_id', 'rule_ids'],
  ['status', 'statuses'],
];

/** Параметры категорийного списка → параметры unified (массивы вместо одиночных). */
export const toUnifiedParams = (params, types) => {
  const next = { ...params, event_types: [...types] };
  SINGLE_TO_PLURAL.forEach(([single, plural]) => {
    const value = next[single];
    delete next[single];
    if (value === '' || value === null || value === undefined) return;
    next[plural] = [value];
  });
  return next;
};

/** Тип строки: event_type из unified, иначе — источник списка. */
export const eventTypeOf = (event, source) => {
  if (event?.event_type === 'violation' || event?.event_type === 'business') return event.event_type;
  return source === 'business' ? 'business' : 'violation';
};
